import { SVGProps } from 'react';

export const UsersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M10 13.2517C10.5553 13.4133 11.1425 13.5 11.75 13.5C12.7358 13.5 13.6683 13.2718 14.4976 12.8652C14.4992 12.827 14.5 12.7886 14.5 12.75C14.5 11.2312 13.2688 10 11.75 10C10.8046 10 9.97068 10.477 9.47572 11.2035M10 13.2517V13.25C10 12.5081 9.80989 11.8105 9.47572 11.2035M10 13.2517C9.99999 13.2755 9.99978 13.2992 9.99939 13.3229C8.75824 14.0702 7.30432 14.5 5.75 14.5C4.19568 14.5 2.74176 14.0702 1.50061 13.3229C1.50021 13.2986 1.5 13.2743 1.5 13.25C1.5 10.9028 3.40279 9 5.75 9C7.35528 9 8.75269 9.88999 9.47572 11.2035M8 4.75C8 5.99264 6.99264 7 5.75 7C4.50736 7 3.5 5.99264 3.5 4.75C3.5 3.50736 4.50736 2.5 5.75 2.5C6.99264 2.5 8 3.50736 8 4.75ZM13.5 6.25C13.5 7.2165 12.7165 8 11.75 8C10.7835 8 10 7.2165 10 6.25C10 5.2835 10.7835 4.5 11.75 4.5C12.7165 4.5 13.5 5.2835 13.5 6.25Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
